import * as Leaflet from 'leaflet';
import { PostType } from '@eview/core/domain/post/post';
import { environment } from '@eview/core/environments/environment';
const defaults = environment.defaults;

export const customIcon = ({
  color,
  icon,
  type
}: {
  color: string;
  icon: string;
  type: string;
}): any => {
  
  const defaultColor = (type === PostType.Risk) ? defaults.tagRiskColor : defaults.tagIncidentColor;
  const ColorTag = (color != null && color != '') ? color : defaultColor;
  
  // For Google Maps, return SVG data URL
  const svgMarker = `
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="64" viewBox="0 0 40 64" fill="none">
      <path d="M20 0C9.1 0 0.5 8.6 0.5 19.5C0.5 34.5 20 64 20 64C20 64 39.5 34.5 39.5 19.5C39.5 8.6 30.9 0 20 0Z" fill="${ColorTag}" stroke="white" stroke-width="1"/>
      <circle cx="20" cy="20" r="8" fill="white"/>
    </svg>


  `;
  
  // Return both Leaflet and Google Maps compatible formats
  return {
    // Leaflet format
    options: {
      iconUrl: `data:image/svg+xml;base64,${btoa(svgMarker)}`,
      iconSize: [32, 40],
      iconAnchor: [16, 40]
    },
    // Google Maps format
    url: `data:image/svg+xml;base64,${btoa(svgMarker)}`,
    size: { width: 32, height: 40 },
    anchor: { x: 16, y: 40 }
  };
};

export const defaultIcon = (type) => customIcon({
  color: null,
  icon: defaults.tagIcon,
  type: defaults.tagType
});
export const userCursorIcon = customIcon({
  color: 'white',
  icon: defaults.tagIcon,
  type: ''
});
export const clickedIcon = (originalColor: string = 'rgb(255, 164, 51)'): any => {
  // Hacer el color más intenso/oscuro para el estado clickeado
  const darkerColor = originalColor.includes('rgb') 
    ? originalColor.replace(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/, (match, r, g, b) => {
        const newR = Math.max(0, parseInt(r) - 60);
        const newG = Math.max(0, parseInt(g) - 60);
        const newB = Math.max(0, parseInt(b) - 60);
        return `rgb(${newR}, ${newG}, ${newB})`;
      })
    : originalColor;
  
  const svgMarker = `
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="68" viewBox="0 0 44 68" fill="none">
      <defs>
        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="0" stdDeviation="4" flood-color="${originalColor}" flood-opacity="0.8"/>
        </filter>
      </defs>
      <path d="M22 0C10.1 0 0.5 9.6 0.5 21.5C0.5 37.5 22 68 22 68C22 68 43.5 37.5 43.5 21.5C43.5 9.6 33.9 0 22 0Z" fill="${darkerColor}" stroke="white" stroke-width="3" filter="url(#glow)"/>
      <circle cx="22" cy="22" r="9" fill="${originalColor}" stroke="white" stroke-width="2"/>
      <circle cx="22" cy="22" r="4" fill="${darkerColor}"/>
    </svg>
  `;
  
  return {
    options: {
      iconUrl: `data:image/svg+xml;base64,${btoa(svgMarker)}`,
      iconSize: [44, 68],
      iconAnchor: [22, 68]
    }
  };
};